import {
  EventLocationResponse,
  EventMemberResponse,
  EventPriceCategoryResponse,
  EventResponse,
  Member,
  MemberResponse,
} from '../shared/types'
import { EventObject } from '../screens/App/Events/EventComponent'

const getEventObject = (
  events: EventResponse,
  eventMember: EventMemberResponse,
  eventPriceCategories: EventPriceCategoryResponse,
  eventLocations: EventLocationResponse,
  members?: MemberResponse,
  searchInput?: string) => {
  const eventObjects: EventObject[] = []
  events.results.map(event => {
    const prices = eventPriceCategories.results.filter(price => price.eventId === event.id)
    const member = eventMember.results.filter(member => member.eventId === event.id)
    const location = eventLocations.results.find(location => location.id === event.locationId)

    if (searchInput) {
      const regEx = new RegExp(searchInput.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss'), 'gim')
      // const regExp = new RegExp((searchInput || '').replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&'), 'i')
      const temp: Member[] = []
      member.map(elem => {
        const tempMem = members?.results.find(mem => mem.id === elem.memberId)
        if ((tempMem && tempMem.firstname.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1) ||
          (tempMem && tempMem.lastname.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)) {
          temp.push(tempMem)
        }
      })

      // Suche in Year, Title, EventLocation
      if ((event?.eventFrom?.year?.toString())?.search(regEx) !== -1 ||
        (event?.eventTo?.year?.toString())?.search(regEx) !== -1 ||
        (event?.title.toString())?.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1 ||
        (temp.length > 0) ||
        (location?.name && location?.name.replace('ä', 'ae').replace('Ä', 'Ae').replace('ö', 'oe').replace('Ö', 'Oe').replace('ü', 'ue').replace('Ü', 'Ue').replace('ß', 'ss').search(regEx) > -1)) {
        eventObjects.push({
          event: event,
          eventPrices: prices,
          eventMember: member,
          eventLocation: location,
          media: [],
        })
      }
    } else {
      eventObjects.push({
        event: event,
        eventPrices: prices,
        eventMember: member,
        eventLocation: location,
        media: [],
      })
    }
  })
  return eventObjects
}

export default getEventObject
